var React = require('react');

function SidebarCircle03Inline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"8","height":"8","fill":"white","key":0}),React.createElement("path",{"d":"M1.38703 4.34961C2.25052 6.5476 3.86842 7.70616 6.03142 6.53617C6.81024 6.1149 7.43428 2.96778 6.61197 2.25611C5.57879 1.36192 4.80148 1 3.12868 1C1.95931 1 1 3.67928 1 4.76832","stroke":"#7F879D","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

SidebarCircle03Inline.defaultProps = {"width":"8","height":"8","viewBox":"0 0 8 8","fill":"none"};

module.exports = SidebarCircle03Inline;

SidebarCircle03Inline.default = SidebarCircle03Inline;
